/**
 * @Auther    william
 * @Name      state define file
 * @Note      
 * @Time      2021/04/13 16:53
 */

let state = {
    systemTag: "crm",
    language: "enUS",
    logo: "",
    theme: "dark",
    copyRight: "Ttech Global Service Limited. All Rights Reserved 2022",
    token: "",
    noImage: require("@/assets/img/no-img-small.png"),
    username: "",
    idRol: "",
    userType: "",
    tenantDb: "",
    portrait: "",
    lastIp: "",
    lastTime: 0,
    phone: "",
    login: "",
    email: "",
    type: 0,
    permissionList:[]
}

export default state